export const COMMIT_HASH = "2904f8ebffcf6505b8905bd6053fa112bdb200f9";
export const SHORTBREAD_VERSION = "1.1.2.2";
